require('./accountAddDocumentationUpload.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

// @ commons
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKFileUpload } = require('commonsComponents/OKFileUpload');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKMessage } = require('commonsComponents/OKMessage');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const WebappRender = require('components/conditionalRender/webappRender')

// @ utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { isDocumentUploadAllowed, isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const {
    recordLink,
} = require('utilities/tagging');
const {
    getAccountPath,
} = require('utilities/accountAddDocumentationTaggingHelper');

const {
    DOCUMENT_TYPE_DNI,
    DOCUMENT_TYPE_NIE_NOT_UE,
    DOCUMENT_TYPE_NIE_UE,
    DOCUMENT_TYPE_PASSPORT,
    MAX_SIZE_FILE,
    VALID_TYPES_FILE,
    VALID_TYPES_FILE_ERROR_MESSAGE,
} = require('constants/accountAddDocumentation');

class AccountAddDocumentationUpload extends React.Component {

    constructor(props) {
        super(props);

        this.handleEditFileName = this.handleEditFileName.bind(this);
        this.handleLinkTagging = this.handleLinkTagging.bind(this);
        this.handleUploadDocumentation = this.handleUploadDocumentation.bind(this);
        this.taggingRecordLink = this.taggingRecordLink.bind(this);
    }

    handleLinkTagging() {
        this.taggingRecordLink('', 'email');
    }

    handleEditFileName(documentName, side, name) {
        const { changeFileName } = this.props;
        this.taggingRecordLink(documentName, 'editar nombre');
        changeFileName(documentName, side, name);
    }

    handleRemoveFile(documentName, side) {
        const { removeFile } = this.props;
        this.taggingRecordLink(documentName, 'eliminar');
        removeFile(documentName, side);
    }

    handleClearErrors(documentName, side) {
        const { removeFile } = this.props;
        this.taggingRecordLink(documentName, 'cerrar');
        removeFile(documentName, side);
    }

    handleUploadDocumentation() {
        const {
            uploadDocumentation,
        } = this.props;
        this.taggingRecordLink('', 'adjuntar');
        uploadDocumentation();
    }

    buildTipsPictures() {
        return (
            <section className="account-add-documentation-upload__tips-container">
                <FormattedText
                    className="account-add-documentation-upload__tips-subtitle"
                    value="accountUploadDocumentation-accountUploadDocumentation_tipsPhotosTitle"
                />
                <div className="row account-add-documentation-upload__tips">
                    <div className="col-xs-3 account-add-documentation-upload__tip">
                        <i className="account-add-documentation-upload__icon icon-superficie-plana" />
                        <FormattedText value="accountUploadDocumentation-accountUploadDocumentation_tipsPhotos1" />
                    </div>
                    <div className="col-xs-3 account-add-documentation-upload__tip account-add-documentation-upload__tip--middle">
                        <i className="account-add-documentation-upload__icon icon-nitidez" />
                        <FormattedText value="accountUploadDocumentation-accountUploadDocumentation_tipsPhotos2" />
                    </div>
                    <div className="col-xs-3 account-add-documentation-upload__tip">
                        <i className="account-add-documentation-upload__icon icon-luz-natural" />
                        <FormattedText value="accountUploadDocumentation-accountUploadDocumentation_tipsPhotos3" />
                    </div>
                    <div className="col-xs-3 account-add-documentation-upload__tip">
                        <i className="account-add-documentation-upload__icon icon-subir" />
                        <FormattedText value="accountUploadDocumentation-accountUploadDocumentation_tipsPhotos4" />
                    </div>
                </div>
            </section>
        );
    }

    buildDocumentationAddress() {
        return (
            <p className="account-add-documentation-upload__message">
                <FormattedText value="accountUploadDocumentation-accountUploadDocumentation_sendByEmail1" />
                &nbsp;
                <a
                    className="ok-link ok-link--emphasize"
                    onClick={this.handleLinkTagging}
                    target="_blank"
                    href="mailto:documentacion@openbank.es"
                >
                    <FormattedText value="accountUploadDocumentation-accountUploadDocumentation_sendByEmailLink" />
                </a>
                &nbsp;
                <FormattedText value="accountUploadDocumentation-accountUploadDocumentation_sendByEmail2" />
            </p>
        );
    }

    buildFooter() {
        const {
            immAccountAddDocumentation,
        } = this.props;
        const isButtonLoading = immAccountAddDocumentation.get('inProgress') || immAccountAddDocumentation.get('inProgressFlag');
        const immFiles = immAccountAddDocumentation.get('files');
        const isFrontDoc = !!immFiles.getIn(['document', 'front', 'file']);
        const isBackDoc = !!immFiles.getIn(['document', 'back', 'file']);
        const isFrontDaal = !!immFiles.getIn(['daal', 'front', 'file']);
        const isFrontReceipt = !!immFiles.getIn(['receipt', 'front', 'file']);
        const isPassport = immAccountAddDocumentation.get('documentTypeForm') === DOCUMENT_TYPE_PASSPORT;
        const thereIsError = (
            immFiles.getIn(['document', 'front', 'error']) ||
            immFiles.getIn(['document', 'back', 'error']) ||
            immFiles.getIn(['daal', 'front', 'error']) ||
            immFiles.getIn(['daal', 'back', 'error']) ||
            immFiles.getIn(['receipt', 'front', 'error']) ||
            immFiles.getIn(['receipt', 'back', 'error'])
        );
        const isButtonDisabled = (
            thereIsError ||
            (isBackDoc !== isFrontDoc && !isPassport) ||
            (!isBackDoc && !isFrontDoc && !isFrontReceipt && !isFrontDaal)
        );

        return (
            <footer className="account-add-documentation-upload__footer">
                <div className="account-add-documentation-upload__cancel-button">
                    <OKLink
                        modifier="inherit-styles"
                        to="/myprofile/accounts"
                    >
                        <FormattedText value="accountUploadDocumentation-accountUploadDocumentation_cancelAddDocumentation" />
                    </OKLink>
                </div>
                <OKButton
                    disabled={isButtonDisabled}
                    loading={isButtonLoading}
                    onClick={this.handleUploadDocumentation}
                >
                    <FormattedText value="accountUploadDocumentation-accountUploadDocumentation_addDocumentation" />
                </OKButton>
            </footer>
        );
    }

    taggingRecordLink(documentName, tagName = '') {
        const { immAccountAddDocumentation } = this.props;
        let docType = '';

        switch (documentName) {
            case 'document':
                docType = 'documentacion de identidad';
                break;
            case 'daal':
                docType = 'documentacion de ingresos';
                break;
            case 'receipt':
                docType = 'documentacion de domicilio';
                break;
        }
        const subtype = immAccountAddDocumentation.get('subtype');
        recordLink(getAccountPath(subtype), docType, tagName);
    }

    handleUploadFile(documentName, side, fileInfo) {
        const { addFile } = this.props;
        this.taggingRecordLink(documentName, 'upload');
        addFile(documentName, side, fileInfo);
    }

    handleErrorUploadFile(documentName, side) {
        const { setErrorFile } = this.props;
        this.taggingRecordLink(documentName, 'error');
        setErrorFile(documentName, side);
    }

    buildDragNDrop(fileProps) {
        const {
            immAccountAddDocumentation,
        } = this.props;
        const {
            documentName,
            side,
            title,
        } = fileProps;
        let file;
        let customTitle;
        let uploadText;
        let uploadLink;

        if (!!immAccountAddDocumentation.getIn(['files', documentName, side, 'file'])) {
            file = {
                name: immAccountAddDocumentation.getIn(['files', documentName, side, 'name']),
            };
        }

        if (!!title) {
            customTitle = formatText(title);
        }

        if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
            uploadText = <FormattedText value="cc_accountUploadDocumentation-accountUploadDocumentation_defaultTextDescriptionDisabled" />;
        } else {
            uploadText = <FormattedText value="accountUploadDocumentation-accountUploadDocumentation_defaultTextDescriptionUpload" />;
            uploadLink = <FormattedText value="accountUploadDocumentation-accountUploadDocumentation_defaultTextLink" />;
        }

        const fileUploadProps = {
            disabled: !isDocumentUploadAllowed(),
            file,
            fileDescription: customTitle,
            handlers: {
                change: fileInfo => this.handleUploadFile(documentName, side, fileInfo),
                clearErrors: () => this.handleClearErrors(documentName, side),
                editFileName: name => this.handleEditFileName(documentName, side, name),
                errorUploadFile: () => this.handleErrorUploadFile(documentName, side),
                removeFile: () => this.handleRemoveFile(documentName, side),
            },
            invalid: immAccountAddDocumentation.getIn(['files', documentName, side, 'error']),
            inValidation: true,
            invalidCloseButton: true,
            loading: immAccountAddDocumentation.get('isFetching') || immAccountAddDocumentation.get('inProgress'),
            maxSize: MAX_SIZE_FILE,
            onChange: fileInfo => this.handleUploadFile(documentName, side, fileInfo),
            overwriteFile: true,
            texts: {
                editFileName: <FormattedText value="accountUploadDocumentation-accountUploadDocumentation_defaultEditFileName" />,
                editReturn: <FormattedText value="accountUploadDocumentation-accountUploadDocumentation_enterToSaveComponent" />,
                errorSize: <FormattedText value="accountUploadDocumentation-accountUploadDocumentation_sizeError" />,
                errorType: <FormattedText value="accountUploadDocumentation-accountUploadDocumentation_typeError" injectedStrings={[VALID_TYPES_FILE_ERROR_MESSAGE.join(', ')]} />,
                errorTypeSize: <FormattedText value="accountUploadDocumentation-accountUploadDocumentation_typeAndSizeError" injectedStrings={[VALID_TYPES_FILE_ERROR_MESSAGE.join(', ')]} />,
                uploadLink,
                uploadText,
            },
            titleLength: 200,
            validTypesFile: VALID_TYPES_FILE,
        }
        return (
            <div className="col-md-4">
                <OKFileUpload {...fileUploadProps} />
            </div>
        );
    }

    buildDocumentsDocumentation() {
        const { immAccountAddDocumentation } = this.props;
        let dragNDropDocBack;
        let dragNDropDocFront;
        let content;
        let ccDocumentationInfo;

        if (immAccountAddDocumentation.get('documentTypeForm') === DOCUMENT_TYPE_DNI) {
            dragNDropDocFront = this.buildDragNDrop({
                documentName: 'document',
                side: 'front',
                title: 'accountUploadDocumentation-accountUploadDocumentation_dniFrontTitle',
            });
            dragNDropDocBack = this.buildDragNDrop({
                documentName: 'document',
                side: 'back',
                title: 'accountUploadDocumentation-accountUploadDocumentation_dniBackTitle',
            });
            content = (
                <React.Fragment>
                    {dragNDropDocFront}
                    {dragNDropDocBack}
                </React.Fragment>
            );
        } else if (immAccountAddDocumentation.get('documentTypeForm') === DOCUMENT_TYPE_PASSPORT) {

            content = this.buildDragNDrop({
                documentName: 'document',
                side: 'front',
                title: 'accountUploadDocumentation-accountUploadDocumentation_passportTitle',
            });
        } else if (immAccountAddDocumentation.get('documentTypeForm') === DOCUMENT_TYPE_NIE_UE || immAccountAddDocumentation.get('documentTypeForm') === DOCUMENT_TYPE_NIE_NOT_UE) {
            dragNDropDocFront = this.buildDragNDrop({
                documentName: 'document',
                side: 'front',
                title: 'accountUploadDocumentation-accountUploadDocumentation_nieFrontTitle',
            });

            if (immAccountAddDocumentation.get('documentTypeForm') === DOCUMENT_TYPE_NIE_UE) {
                dragNDropDocBack = this.buildDragNDrop({
                    documentName: 'document',
                    side: 'back',
                    title: 'accountUploadDocumentation-accountUploadDocumentation_passportTitle',
                });
            } else {
                dragNDropDocBack = this.buildDragNDrop({
                    documentName: 'document',
                    side: 'back',
                    title: 'accountUploadDocumentation-accountUploadDocumentation_nieBackTitle',
                });
            }

            content = (
                <React.Fragment>
                    {dragNDropDocFront}
                    {dragNDropDocBack}
                </React.Fragment>
            );
        }

        if (__CONTACT_CENTER__) {
            ccDocumentationInfo = (
                <div className="account-add-documentation-upload__header--cc">
                    <OKMessage type="informative">
                        <FormattedText value="cc_accountUploadDocumentation-accountUploadDocumentation_messageCantUploadDoc" />
                    </OKMessage>
                </div>
            );
        }

        return (
            <React.Fragment>
                <FormattedText
                    className="account-add-documentation-upload__subtitle"
                    value="accountUploadDocumentation-accountUploadDocumentation_documentationIdentityTitle"
                />
                <WebappRender>
                    <OKTooltip
                        content="accountUploadDocumentation-accountUploadDocumentation_documentationIdentityTitleTooltip"
                        offset={[15, 0]}
                        onHover={() => this.taggingRecordLink('document', 'tooltip')}
                        placement="right"
                    />
                </WebappRender>
                {ccDocumentationInfo}
                <div className="account-add-documentation-upload__box-upload-files row">
                    {content}
                </div>
            </React.Fragment>
        );
    }

    buildDaalDocumentation() {
        const { immAccountAddDocumentation } = this.props;
        const immDaal = immAccountAddDocumentation.getIn(['files', 'daal']);
        const dragNDropDaalFront = this.buildDragNDrop({
            documentName: 'daal',
            side: 'front',
        });
        let dragNDropDaalBack;
        let ccDaalInfo;

        if (!!immDaal.getIn(['back', 'file']) || !!immDaal.getIn(['back', 'error']) || !!immDaal.getIn(['front', 'file'])) {
            dragNDropDaalBack = this.buildDragNDrop({
                documentName: 'daal',
                side: 'back',
            });
        }

        if (__CONTACT_CENTER__) {
            ccDaalInfo = (
                <div className="account-add-documentation-upload__header--cc">
                    <OKMessage className="account-add-documentation-upload__header--cc" type="informative">
                        <FormattedText value="cc_accountUploadDocumentation-accountUploadDocumentation_messageCantUploadDaal" />
                    </OKMessage>
                </div>
            );
        }

        return (
            <React.Fragment>
                <FormattedText
                    className="account-add-documentation-upload__subtitle"
                    value="accountUploadDocumentation-accountUploadDocumentation_documentationEarnTitle"
                />
                <WebappRender>
                    <OKTooltip
                        content="accountUploadDocumentation-accountUploadDocumentation_documentationAddressTitleTooltip"
                        offset={[15, 0]}
                        onHover={() => this.taggingRecordLink('daal', 'tooltip')}
                        placement="right"
                    />
                </WebappRender>
                {ccDaalInfo}
                <div className="account-add-documentation-upload__box-upload-files row">
                    <div className="col-md-12">
                        <FormattedText
                            className="account-add-documentation-upload__file-upload-title"
                            value="accountUploadDocumentation-accountUploadDocumentation_daalTitle"
                        />
                    </div>
                    {dragNDropDaalFront}
                    {dragNDropDaalBack}
                </div>
            </React.Fragment>
        );
    }

    buildReceiptDocumentation() {
        const { immAccountAddDocumentation } = this.props;
        const immReceipt = immAccountAddDocumentation.getIn(['files', 'receipt']);
        const dragNDropReceiptFront = this.buildDragNDrop({
            documentName: 'receipt',
            side: 'front',
        });
        let dragNDropReceiptBack;
        let ccReceiptInfo;

        if (!!immReceipt.getIn(['back', 'file']) || !!immReceipt.getIn(['back', 'error']) || !!immReceipt.getIn(['front', 'file'])) {
            dragNDropReceiptBack = this.buildDragNDrop({
                documentName: 'receipt',
                side: 'back',
            });
        }

        if (__CONTACT_CENTER__) {
            ccReceiptInfo = (
                <div className="account-add-documentation-upload__header--cc">
                    <OKMessage className="account-add-documentation-upload__header--cc" type="informative">
                        <FormattedText value="cc_accountUploadDocumentation-accountUploadDocumentation_messageCantUploadReceipt" />
                    </OKMessage>
                </div>
            );
        }

        return (
            <React.Fragment>
                <FormattedText
                    className="account-add-documentation-upload__subtitle"
                    value="accountUploadDocumentation-accountUploadDocumentation_documentationAddressTitle"
                />
                <WebappRender>
                    <OKTooltip
                        content="accountUploadDocumentation-accountUploadDocumentation_documentationEarnTitleTooltip"
                        offset={[15, 0]}
                        onHover={() => this.taggingRecordLink('receipt', 'tooltip')}
                        placement="right"
                    />
                </WebappRender>
                {ccReceiptInfo}
                <div className="account-add-documentation-upload__box-upload-files row">
                    <div className="col-md-12">
                        <FormattedText
                            className="account-add-documentation-upload__file-upload-title"
                            value="accountUploadDocumentation-accountUploadDocumentation_receiptTitle"
                        />
                    </div>
                    {dragNDropReceiptFront}
                    {dragNDropReceiptBack}
                </div>
            </React.Fragment>
        );
    }

    render() {
        const { immAccountAddDocumentation } = this.props;
        const sendDocumentationAddress = this.buildDocumentationAddress();
        const footer = this.buildFooter();
        let pictures;
        let docDocumentation;
        let daalDocumentation;
        let receiptDocumentation;
        let ccMessageCantUploadDocumentation;
        let content = <LoadingSection />;

        if (immAccountAddDocumentation.getIn(['files', 'document', 'isVisible']) && !immAccountAddDocumentation.getIn(['files', 'document', 'done'])) {
            docDocumentation = this.buildDocumentsDocumentation();
        }

        if (immAccountAddDocumentation.getIn(['files', 'daal', 'isVisible']) && !immAccountAddDocumentation.getIn(['files', 'daal', 'done'])) {
            daalDocumentation = this.buildDaalDocumentation();
        }

        if (immAccountAddDocumentation.getIn(['files', 'receipt', 'isVisible']) && !immAccountAddDocumentation.getIn(['files', 'receipt', 'done'])) {
            receiptDocumentation = this.buildReceiptDocumentation();
        }

        if (!isPrintOfficeMode()) {
            pictures = this.buildTipsPictures();
        }

        if (__CONTACT_CENTER__) {
            const translationKey = isPrintOfficeMode() ? 'messageCantUploadDocTitleOffice' : 'messageCantUploadDocTitle';
            ccMessageCantUploadDocumentation = (
                <BlockInfo extraClass="account-add-documentation-upload__header--cc">
                    <FormattedText value={`cc_accountUploadDocumentation-accountUploadDocumentation_${translationKey}`} />
                </BlockInfo>
            );
        }

        if (!immAccountAddDocumentation.get('isFetching')) {
            content = (
                <React.Fragment>
                    <FormattedText
                        className="account-add-documentation-upload__header"
                        value="accountUploadDocumentation-accountUploadDocumentation_uploadDocumentationTitle"
                    />
                    {ccMessageCantUploadDocumentation}
                    {pictures}
                    {docDocumentation}
                    {daalDocumentation}
                    {receiptDocumentation}
                    {sendDocumentationAddress}
                    {footer}
                </React.Fragment>
            );
        }

        return content;
    }
}

AccountAddDocumentationUpload.propTypes = {
    addFile: PropTypes.func.isRequired,
    changeFileName: PropTypes.func.isRequired,
    immAccountAddDocumentation: PropTypes.object.isRequired,
    removeFile: PropTypes.func.isRequired,
    setErrorFile: PropTypes.func.isRequired,
    uploadDocumentation: PropTypes.func.isRequired,
};

module.exports = AccountAddDocumentationUpload;
